import { Injectable, EventEmitter } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { Program } from "@models/program";
import { ActNowDictionaryItem } from "@models/common";

@Injectable()
export class ProgramEditorService {
    public previousUrl: string;

    private _currentTabSrc = new BehaviorSubject<number>(undefined);
    private _programSrc = new BehaviorSubject<Program>(new Program());
    private _contactInfoValidSrc = new BehaviorSubject<boolean>(false);
    private _submissionValidSrc = new BehaviorSubject<boolean>(false);
    private _showContactInfoErrorsSrc = new BehaviorSubject<boolean>(false);
    private _showSubmitErrorsSrc = new BehaviorSubject<boolean>(false);


    currentTab$ = this._currentTabSrc.asObservable();
    program$ = this._programSrc.asObservable();
    contactInfoValid$ = this._contactInfoValidSrc.asObservable();
    submissionValid$ = this._submissionValidSrc.asObservable();
    showContactInfoErrors$ = this._showContactInfoErrorsSrc.asObservable();
    showSubmitErrors$ = this._showSubmitErrorsSrc.asObservable();

    updateSubmitValidation: EventEmitter<void> = new EventEmitter<void>();

    dataReady$: EventEmitter<void> = new EventEmitter<void>();
    dataReady: boolean = false;

    compareData: Program;
    compareDataReady$: EventEmitter<void> = new EventEmitter<void>();
    compareDataReady: boolean = false;

    agencies: ActNowDictionaryItem[];
    hasAgencies: boolean = false;
    agencyFetch$: EventEmitter<void> = new EventEmitter<void>();
    cities: ActNowDictionaryItem[];
    hasCities: boolean = false;
    cityFetch$: EventEmitter<void> = new EventEmitter<void>();

    licensingOpts: ActNowDictionaryItem[];
    licensingOptsReady: boolean = false;
    licensingOpts$: EventEmitter<void> = new EventEmitter<void>();
    physicalSettings: ActNowDictionaryItem[];
    physicalSettingsReady: boolean = false;
    physicalSettings$: EventEmitter<void> = new EventEmitter<void>();
    defaultOpts: any = { valueField: "id", highlight: false };

    agencyTooltip: string = "Please enter or select full agency name. e.g. \"Illinois State Alliance of YMCA's\" instead of \"YMCA\"";
    servedTooltip: string = "1st Grade and Older";
    staffTooltip: string = "Staff with Post-Secondary Degree or Credential";
    enrollTooltip: string = "Enter any specific eligibility for participating in the program, such as: gender, income, school designation, special referrals, selective application, special needs, etc.";
    qualityTooltip: string = "<span>What are ACT Now's Quality Standards? <a class='white-link' href='http://www.actnowillinois.org/quality-standards/' target='_blank'>Click here</a> to learn more!</span>";
    falseValue: boolean = false;

    updateCurrentTab(value: number) {
        this._currentTabSrc.next(value);
    }

    updateProgram(program: Program) {
        this._programSrc.next(program);
        if (!this.dataReady) {
            this.dataReady = true;
            this.dataReady$.next();
        }
    }

    triggerCompareDataReady() {
        if (!this.compareDataReady) {
            this.compareDataReady = true;
            this.compareDataReady$.next();
        }
    }

    updateContactInfoValidity(value: boolean) {
        this._contactInfoValidSrc.next(value);
    }

    updateSubmissionValidity(value: boolean) {
        this._submissionValidSrc.next(value);
    }

    updateShowContactInfoErrors(value: boolean) {
        this._showContactInfoErrorsSrc.next(value);
    }

    updateShowSubmitErrors(value: boolean) {
        this._showSubmitErrorsSrc.next(value);
    }

    getProgram() {
        return this._programSrc.value;
    }

    getShowSubmitErrors() {
        return this._showSubmitErrorsSrc.value;
    }

    completeCitiesFetch() {
        this.hasCities = true;
        this.cityFetch$.next();
    }

    completeAgenciesFetch() {
        this.hasAgencies = true;
        this.agencyFetch$.next();
    }

    completeLicensingOptsFetch() {
        this.licensingOptsReady = true;
        this.licensingOpts$.next();
    }

    completePhysicalSettingsFetch() {
        this.physicalSettingsReady = true;
        this.physicalSettings$.next();
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/common/program-editors/program-editor.service.ts